import { Box, Container } from '@mui/material';
import React, { useEffect } from 'react';

export const SuperCounter = () => {

    useEffect(() => {
        const script1 = document.createElement('script');
        script1.src = '//widget.supercounters.com/ssl/online_i.js';
        script1.async = true;
        document.body.appendChild(script1);

        script1.onload = () => {
            const script2 = document.createElement('script');
            script2.innerHTML = 'sc_online_i(1692238,"fff","11783C");';
            document.body.appendChild(script2);
        };

        return () => {
            document.body.removeChild(script1);
        };
    }, []);

    return (
        <Box component={Container} mt={120}>
            <noscript>
                <a href="https://www.supercounters.com/">free online counter</a>
            </noscript>
        </Box>
    );
};